import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import homeicon from "../Images/house.png";
import sales from "../Images/sales.png";
import customer from "../Images/customer.png";
import stock from "../Images/stock.png";
import appointment from "../Images/appointment.png";
import logout from "../Images/logout.png";

const navLinkClass = ({ isActive }) =>
  isActive ? "nav-link tab-item active" : "nav-link tab-item";

const tabs = [
  { to: "/home", label: "Dashboard", icon: homeicon, end: true },
  { to: "/customers", label: "Customer", icon: customer },
  { to: "/stocks", label: "Stock", icon: stock },
  { to: "/list", label: "List", icon: appointment },
  { to: "/sales", label: "Sales", icon: sales },
  { to: "/loans", label: "Loan", icon: customer },
  { to: "/salary", label: "Salary", icon: sales },
  { to: "/expenses", label: "Expenses", icon: appointment },
  { to: "/history", label: "History", icon: appointment },
];

const topTabs = [...tabs];
// Show only the four most important tabs on mobile bottom nav
const bottomTabs = [tabs[0], tabs[1], tabs[2], tabs[4]];

function AppNav({ tabs = bottomTabs, variant = "top", onItemClick }) {
  return (
    <nav className={`app-nav app-nav--${variant}`} aria-label="Main navigation">
      <ul>
        {tabs.map((tab) => (
          <li key={tab.to}>
            <NavLink
              to={tab.to}
              className={navLinkClass}
              end={tab.end}
              onClick={() => onItemClick && onItemClick()}
            >
              <img src={tab.icon} alt="" className="tab-item__icon" />
              <span className="tab-item__label">{tab.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

const Header = () => {
  const [sideOpen, setSideOpen] = useState(false);

  function closeSide() {
    setSideOpen(false);
  }

  return (
    <>
      <header className="header header--top">
        <div className="header__inner">
          <button
            className="hamburger"
            aria-label="Open menu"
            onClick={() => setSideOpen(true)}
          >
            <span />
            <span />
            <span />
          </button>
          <div className="logo">
            <NavLink to="/home" className="logo-link">
              <span className="logo-mark" aria-hidden="true">
                R
              </span>
              <span className="logo-text">Royallty</span>
            </NavLink>
          </div>
          <div className="header__actions">
            <div className="header--top-nav d-none d-md-flex">
              <AppNav tabs={topTabs} variant="top" />
            </div>
            <NavLink to="/logout" className="logout-button">
              <img src={logout} alt="Logout" className="logout-button__icon" />
              <span>Logout</span>
            </NavLink>
          </div>
        </div>
      </header>
      {/* Side drawer for mobile */}
      <div
        className={`sidenav-backdrop ${sideOpen ? "is-open" : ""}`}
        onClick={closeSide}
      />
      <aside
        className={`app-sidenav ${sideOpen ? "is-open" : ""}`}
        aria-hidden={!sideOpen}
      >
        <div className="app-sidenav__head">
          <div className="sidenav-brand">
            <NavLink to="/home" className="logo-link" onClick={closeSide}>
              <span className="logo-mark">R</span>
              <span className="logo-text">Royallty</span>
            </NavLink>
          </div>
          <button
            className="sidenav-close"
            onClick={closeSide}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>
        <div className="app-sidenav__body">
          <AppNav tabs={topTabs} variant="side" onItemClick={closeSide} />
        </div>
      </aside>
      <header className="header header--bottom" aria-label="Mobile navigation">
        <AppNav variant="bottom" />
      </header>
    </>
  );
};

export default Header;
